import react, { useState } from "react";
import * as S from "./styles";
import { BsGear } from "react-icons/bs";

export default function Dropdown({ items, permissions }) {
  const [open, setOpen] = useState(false);

  const getContainsPermission = (
    permissionsByPage = [],
    permissionsByUser = []
  ) => {
    let existPermission = false;

    permissionsByPage.forEach((per) => {
      if (permissionsByUser.includes(per)) {
        existPermission = true;
      }
    });

    return existPermission;
  };

  return (
    <S.Wrapper>
      <S.Title open={open} onClick={() => setOpen(!open)}>
        <BsGear size={20} />
      </S.Title>

      {open && (
        <S.SubLinks>
          {items.map((item) => {
            if (getContainsPermission(item.permissions, permissions)) {
              return (
                <S.SubLink
                  key={item.id}
                  to={item.link}
                  activeStyle={{
                    fontWeight: "bold",
                    color: "#fff",
                  }}
                >
                  {item.text}
                </S.SubLink>
              );
            }
          })}
        </S.SubLinks>
      )}
    </S.Wrapper>
  );
}
